module.exports = __webpack_public_path__ + "img/3.1.4b10d5ec.svg";